import React from 'react';
import PropTypes from 'prop-types';

import { POOLED_PLATES } from 'src/constants/forms';

import { orderPlates } from './helpers';
import PooledPlatesOrderingComponent from './PooledPlatesOrderingComponent';

const PooledPlatesOrderingContainer = ({
  plates,
  platePooling,
  onChangeData,
  formData,
}) => {
  React.useEffect(() => {
    const newPlates = orderPlates(platePooling, plates);

    onChangeData(newPlates, POOLED_PLATES, true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platePooling]);

  return <PooledPlatesOrderingComponent orderedPlates={formData[POOLED_PLATES]?.value || []} />;
};

PooledPlatesOrderingContainer.propTypes = {
  plates: PropTypes.array,
  platePooling: PropTypes.string,
  onChangeData: PropTypes.func.isRequired,
  formData: PropTypes.object,
};

export default PooledPlatesOrderingContainer;
